import React, { useCallback, useState } from 'react';
import Page from '../common/Page';
import { ScheduleMeetingModal } from '../ScheduleMeetingModal';
import { BaseProps } from '../../types';
import Plans from './Plans';

const Pricing: React.FunctionComponent<BaseProps> = () => {
    const [showMeetingModal, setShowMeetingModal] = useState<boolean>(false)
    const onCloseModal = useCallback(() => {
        setShowMeetingModal(false)
    }, [])
    
    const onShowModal = useCallback(() => {
        setShowMeetingModal(true)
    }, [])

    return (
        <Page>
            <ScheduleMeetingModal visible={showMeetingModal} onClose={onCloseModal} />
            <Plans
                pageTitle={'Pricing'} 
                actionTitle={'Schedule A Demo'}
                baseAction={onShowModal}
                proAction={onShowModal}
                eliteAction={onShowModal}
            />
        </Page>
    )
}
export default Pricing